<template>
    <div id="frm_booking" v-if="api && booking.pos_id && booking.pos_parent">
        <form action="" method="post" class="frm_booking" @submit.prevent="booking_online" v-if="stepActive==='1'">
            <div class="form-head">
              <div class="form-head__image">
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip_booking0)">
                    <path d="M5.13281 35.4365V61.2963C5.13281 62.7895 6.34327 64 7.83652 64H11.1612C12.6544 64 13.8649 62.7895 13.8649 61.2963V35.4365H5.13281Z" fill="url(#paint0_linear)"/>
                    <path d="M50.1348 35.4365V61.2963C50.1348 62.7895 51.3452 64 52.8385 64H56.1631C57.6564 64 58.8668 62.7895 58.8668 61.2963V35.4365H50.1348Z" fill="url(#paint1_linear)"/>
                    <path d="M4.02687 27.0042L59.9721 27.0042C62.1563 27.0042 63.9268 28.7746 63.9269 30.9589V34.7753C63.9269 36.9594 62.1564 38.7299 59.9723 38.7299H45.6135L45.6135 38.7298L4.02687 38.7298C1.84276 38.7298 0.0722656 36.9593 0.0722656 34.7752V30.9588C0.0722656 28.7746 1.84276 27.0042 4.02687 27.0042Z" fill="url(#paint2_linear)"/>
                    <path d="M9.49805 27.0042L26.3373 49.2214C27.6804 50.9935 29.7757 52.0346 31.9993 52.0346C34.2228 52.0346 36.3182 50.9936 37.6613 49.2214L54.5005 27.0042H9.49805Z" fill="url(#paint3_linear)"/>
                    <path d="M50.3777 27H8.78478C7.50003 27 6.57026 25.9646 6.70812 24.6872L8.65077 6.68784C8.78863 5.4105 9.94191 4.375 11.2267 4.375H52.8197C54.1045 4.375 55.0342 5.4105 54.8963 6.68784L52.9537 24.6872C52.8157 25.9646 51.6625 27 50.3777 27Z" fill="url(#paint4_linear)"/>
                    <path d="M55.2615 27H13.6685C12.3838 27 11.2305 25.9646 11.0927 24.6872L9.15001 6.68784C9.01215 5.4105 9.94191 4.375 11.2267 4.375H52.8197C54.1044 4.375 55.2577 5.4105 55.3956 6.68784L57.3382 24.6872C57.476 25.9646 56.5462 27 55.2615 27Z" fill="url(#paint5_linear)"/>
                    <path d="M24.7104 13.2969C25.1722 13.2969 25.5884 13.6724 25.6382 14.1338C25.6796 14.517 26.0256 14.8276 26.411 14.8276C26.7964 14.8276 27.0753 14.517 27.0339 14.1338C26.9015 12.9072 25.792 11.9092 24.5607 11.9092C23.3293 11.9092 22.4352 12.9072 22.5676 14.1338L22.5705 14.1609C22.7029 15.3875 23.8124 16.3855 25.0438 16.3855C25.5055 16.3855 25.9218 16.7609 25.9716 17.2223L25.9745 17.2494C26.0243 17.7109 25.6892 18.0863 25.2274 18.0863C24.7655 18.0863 24.3494 17.7108 24.2996 17.2494C24.2582 16.8663 23.9122 16.5556 23.5268 16.5556C23.1414 16.5556 22.8625 16.8663 22.9039 17.2494C23.0363 18.476 24.1458 19.474 25.3771 19.474C26.6085 19.474 27.5026 18.476 27.3702 17.2494L27.3673 17.2223C27.2349 15.9957 26.1254 14.9977 24.894 14.9977C24.4323 14.9977 24.016 14.6223 23.9662 14.1609L23.9633 14.1338C23.9136 13.6723 24.2487 13.2969 24.7104 13.2969Z" fill="url(#paint6_linear)"/>
                    <path d="M14.3309 11.9092H12.8689C12.2456 11.9092 11.7929 12.4139 11.8599 13.0343L12.1464 15.689C12.1465 15.6899 12.1464 15.6907 12.1465 15.6916L12.4799 18.7803C12.5212 19.1635 12.8672 19.4741 13.2526 19.4741C13.638 19.4741 13.9169 19.1635 13.8756 18.7803L13.6171 16.3855H14.2082L15.2837 18.9823C15.4077 19.2816 15.7051 19.4743 16.0042 19.4743C16.0715 19.4743 16.1389 19.4645 16.2045 19.444C16.5611 19.3324 16.7272 18.9447 16.5754 18.5781L15.5926 16.2052C16.1949 15.906 16.5667 15.2637 16.4864 14.5191L16.4061 13.7755C16.2951 12.7464 15.3641 11.9092 14.3309 11.9092ZM15.0906 14.5191C15.1191 14.783 14.9278 14.9977 14.6642 14.9977H14.5833C14.5807 14.9977 14.5781 14.9977 14.5755 14.9977H13.4676L13.284 13.2968H14.4807C14.7444 13.2968 14.982 13.5115 15.0104 13.7755L15.0906 14.5191Z" fill="url(#paint7_linear)"/>
                    <path d="M20.7845 13.2969C21.17 13.2969 21.4489 12.9863 21.4075 12.6031C21.3661 12.2199 21.0202 11.9093 20.6348 11.9093H17.8433C17.4578 11.9093 17.1789 12.2199 17.2203 12.6031L17.887 18.7803C17.9283 19.1635 18.2743 19.4741 18.6597 19.4741H21.4512C21.8366 19.4741 22.1155 19.1635 22.0741 18.7803C22.0328 18.3971 21.6868 18.0865 21.3014 18.0865H19.2079L19.0734 16.8407H21.167C21.5524 16.8407 21.8313 16.53 21.79 16.1469C21.7486 15.7637 21.4027 15.453 21.0173 15.453H18.9237L18.691 13.297L20.7845 13.2969Z" fill="url(#paint8_linear)"/>
                    <path d="M31.5653 13.2969C31.9508 13.2969 32.2297 12.9863 32.1883 12.6031C32.1469 12.2199 31.801 11.9093 31.4156 11.9093H28.6241C28.2387 11.9093 27.9598 12.2199 28.0012 12.6031L28.6679 18.7803C28.7092 19.1635 29.0552 19.4741 29.4406 19.4741H32.232C32.6175 19.4741 32.8964 19.1635 32.855 18.7803C32.8136 18.3971 32.4677 18.0865 32.0823 18.0865H29.9887L29.8542 16.8407H31.9478C32.3332 16.8407 32.6121 16.53 32.5708 16.1469C32.5294 15.7637 32.1835 15.453 31.7981 15.453H29.7045L29.4718 13.297L31.5653 13.2969Z" fill="url(#paint9_linear)"/>
                    <path d="M35.702 11.9092H34.24C33.6167 11.9092 33.1641 12.4139 33.231 13.0343L33.5175 15.689C33.5176 15.6899 33.5176 15.6907 33.5177 15.6916L33.8511 18.7803C33.8924 19.1635 34.2384 19.4741 34.6238 19.4741C35.0092 19.4741 35.2881 19.1635 35.2468 18.7803L34.9883 16.3855H35.5794L36.6549 18.9823C36.7789 19.2816 37.0763 19.4743 37.3754 19.4743C37.4427 19.4743 37.5101 19.4645 37.5757 19.444C37.9323 19.3324 38.0984 18.9447 37.9466 18.5781L36.9638 16.2052C37.5661 15.906 37.9379 15.2637 37.8576 14.5191L37.7773 13.7755C37.6662 12.7464 36.7352 11.9092 35.702 11.9092ZM36.4618 14.5191C36.4903 14.783 36.299 14.9977 36.0354 14.9977H35.9545C35.9519 14.9977 35.9493 14.9977 35.9467 14.9977H34.8387L34.6551 13.2968H35.8518C36.1155 13.2968 36.3531 13.5115 36.3815 13.7755L36.4618 14.5191Z" fill="url(#paint10_linear)"/>
                    <path d="M43.0119 11.9426C42.6322 11.8252 42.2608 12.0257 42.182 12.3904L41.2911 16.5165L39.5095 12.3904C39.352 12.0257 38.9376 11.8252 38.583 11.9426C38.2288 12.0601 38.0694 12.451 38.2269 12.8157L40.8941 18.9929C41.0179 19.2797 41.3074 19.4741 41.6104 19.4741C41.9134 19.4741 42.1608 19.2797 42.2228 18.9929L43.5567 12.8157C43.6352 12.4509 43.3915 12.0601 43.0119 11.9426Z" fill="url(#paint11_linear)"/>
                    <path d="M47.9145 13.2969C48.2999 13.2969 48.5788 12.9863 48.5374 12.6031C48.4961 12.2199 48.1501 11.9093 47.7647 11.9093H44.9733C44.5879 11.9093 44.309 12.2199 44.3503 12.6031L45.017 18.7803C45.0584 19.1635 45.4043 19.4741 45.7897 19.4741H48.5812C48.9666 19.4741 49.2455 19.1635 49.2041 18.7803C49.1628 18.3971 48.8168 18.0865 48.4314 18.0865H46.3378L46.2034 16.8407H48.297C48.6824 16.8407 48.9613 16.53 48.9199 16.1469C48.8786 15.7637 48.5326 15.453 48.1472 15.453H46.0536L45.8209 13.297L47.9145 13.2969Z" fill="url(#paint12_linear)"/>
                    <path d="M50.3572 11.9092C49.8678 11.9092 49.5124 12.305 49.5649 12.7916L50.1909 18.5917C50.2434 19.0783 50.6843 19.4741 51.1736 19.4741C53.147 19.4741 54.5802 17.8779 54.3685 15.9159L54.3201 15.4674C54.1083 13.5053 52.3306 11.9092 50.3572 11.9092ZM52.9727 15.9159C53.0831 16.9388 52.4605 17.7987 51.5257 18.027L51.0216 13.3563C52.0057 13.5846 52.8139 14.4445 52.9243 15.4674L52.9727 15.9159Z" fill="url(#paint13_linear)"/>
                  </g>
                  <defs>
                    <linearGradient id="paint0_linear" x1="9.49885" y1="35.4365" x2="9.49885" y2="64" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#FAAF42"/>
                      <stop offset="1" stop-color="#F15B2C"/>
                    </linearGradient>
                    <linearGradient id="paint1_linear" x1="54.5008" y1="35.4365" x2="54.5008" y2="64" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#FAAF42"/>
                      <stop offset="1" stop-color="#F15B2C"/>
                    </linearGradient>
                    <linearGradient id="paint2_linear" x1="30.2258" y1="27.0042" x2="30.2258" y2="38.7299" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#F15B2C"/>
                      <stop offset="1" stop-color="#BC2030"/>
                    </linearGradient>
                    <linearGradient id="paint3_linear" x1="31.9993" y1="27.0042" x2="31.9993" y2="52.0346" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#F7F3F2" stop-opacity="0.75"/>
                      <stop offset="1" stop-color="#F7F3F2"/>
                    </linearGradient>
                    <linearGradient id="paint4_linear" x1="30.7386" y1="4.375" x2="30.7386" y2="27" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#F15B2C"/>
                      <stop offset="1" stop-color="#BC2030"/>
                    </linearGradient>
                    <linearGradient id="paint5_linear" x1="32.0232" y1="4.375" x2="32.0232" y2="27" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#FAAF42"/>
                      <stop offset="1" stop-color="#F15B2C"/>
                    </linearGradient>
                    <linearGradient id="paint6_linear" x1="32.8372" y1="11.9091" x2="32.8372" y2="19.4743" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#F7F3F2" stop-opacity="0.75"/>
                      <stop offset="1" stop-color="#F7F3F2"/>
                    </linearGradient>
                    <linearGradient id="paint7_linear" x1="32.8372" y1="11.9091" x2="32.8372" y2="19.4743" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#F7F3F2" stop-opacity="0.75"/>
                      <stop offset="1" stop-color="#F7F3F2"/>
                    </linearGradient>
                    <linearGradient id="paint8_linear" x1="32.8372" y1="11.9091" x2="32.8372" y2="19.4743" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#F7F3F2" stop-opacity="0.75"/>
                      <stop offset="1" stop-color="#F7F3F2"/>
                    </linearGradient>
                    <linearGradient id="paint9_linear" x1="32.8372" y1="11.9091" x2="32.8372" y2="19.4743" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#F7F3F2" stop-opacity="0.75"/>
                      <stop offset="1" stop-color="#F7F3F2"/>
                    </linearGradient>
                    <linearGradient id="paint10_linear" x1="32.8372" y1="11.9091" x2="32.8372" y2="19.4743" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#F7F3F2" stop-opacity="0.75"/>
                      <stop offset="1" stop-color="#F7F3F2"/>
                    </linearGradient>
                    <linearGradient id="paint11_linear" x1="32.8372" y1="11.9091" x2="32.8372" y2="19.4743" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#F7F3F2" stop-opacity="0.75"/>
                      <stop offset="1" stop-color="#F7F3F2"/>
                    </linearGradient>
                    <linearGradient id="paint12_linear" x1="32.8372" y1="11.9091" x2="32.8372" y2="19.4743" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#F7F3F2" stop-opacity="0.75"/>
                      <stop offset="1" stop-color="#F7F3F2"/>
                    </linearGradient>
                    <linearGradient id="paint13_linear" x1="32.8372" y1="11.9091" x2="32.8372" y2="19.4743" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#F7F3F2" stop-opacity="0.75"/>
                      <stop offset="1" stop-color="#F7F3F2"/>
                    </linearGradient>
                    <clipPath id="clip_booking0">
                      <rect width="64" height="64" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <div class="form-head__title">
                <h3>Đặt bàn</h3>
                <p>Đặt bàn trước để Sườn Mười có thể phục vụ tốt nhất</p>
              </div>

            </div>
            <div class="form-group booking">
              <div class="booking-restaurants" v-if="restaurants" :class="{'is-open': posSelecting}">
                <svg
                  @click.prevent="posSelecting = !posSelecting"
                  class="booking-caret" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.7071 7.29289C21.0676 7.65338 21.0953 8.22061 20.7903 8.6129L20.7071 8.70711L12.7071 16.7071C12.3466 17.0676 11.7794 17.0953 11.3871 16.7903L11.2929 16.7071L3.2929 8.70711C2.9024 8.31658 2.9024 7.68342 3.2929 7.29289C3.6534 6.93241 4.2206 6.90468 4.6129 7.2097L4.7071 7.29289L12 14.5858L19.2929 7.29289C19.6834 6.90237 20.3166 6.90237 20.7071 7.29289Z" fill="#ADA8A8"/>
                </svg>

                <template v-for="restaurant in restaurants">
                  <div class="booking-restaurant"
                       :class="{'is-active': pos === restaurant}"
                       @click.prevent="selectChange(restaurant)"
                  >
                    <p class="booking-restaurant__name">{{restaurant.name}}</p>
                    <p class="booking-restaurant__addr">{{restaurant.address}}</p>
                  </div>
                </template>

              </div>
            </div>
            <div class="form-group">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.7545 13.9999C18.9966 13.9999 20.0034 15.0068 20.0034 16.2488V17.1673C20.0034 17.7406 19.8242 18.2996 19.4908 18.7661C17.9449 20.9294 15.4206 22.0011 12.0004 22.0011C8.5794 22.0011 6.05643 20.9289 4.51427 18.7646C4.18231 18.2987 4.00391 17.7408 4.00391 17.1688V16.2488C4.00391 15.0068 5.01076 13.9999 6.25278 13.9999H17.7545ZM12.0004 2.00464C14.7618 2.00464 17.0004 4.24322 17.0004 7.00464C17.0004 9.76607 14.7618 12.0046 12.0004 12.0046C9.23894 12.0046 7.00036 9.76607 7.00036 7.00464C7.00036 4.24322 9.23894 2.00464 12.0004 2.00464Z" fill="#ADA8A8"/>
                </svg>
              <input type="text" class="form-control" name="username" v-model="booking.username" autocomplete="off" placeholder="Tên người đặt bàn">
            </div>
            <div class="form-group">
              <div class="form-field one-half">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.754 10C15.7205 10 16.504 10.7835 16.504 11.75V16.499C16.504 18.9848 14.4888 21 12.003 21C9.51712 21 7.50193 18.9848 7.50193 16.499V11.75C7.50193 10.7835 8.28543 10 9.25193 10H14.754ZM7.13128 9.99906C6.78183 10.4218 6.55636 10.9508 6.51057 11.5304L6.50193 11.75V16.499C6.50193 17.3456 6.69319 18.1476 7.03487 18.864C6.70577 18.953 6.35899 19 6.00124 19C3.79142 19 2 17.2086 2 14.9988V11.75C2 10.8318 2.70711 10.0788 3.60647 10.0058L3.75 10L7.13128 9.99906ZM16.8747 9.99906L20.25 10C21.2165 10 22 10.7835 22 11.75V15C22 17.2091 20.2091 19 18 19C17.6436 19 17.298 18.9534 16.9691 18.8659C17.2697 18.238 17.4538 17.5452 17.4951 16.8144L17.504 16.499V11.75C17.504 11.0847 17.2678 10.4747 16.8747 9.99906ZM12 3C13.6569 3 15 4.34315 15 6C15 7.65685 13.6569 9 12 9C10.3431 9 9 7.65685 9 6C9 4.34315 10.3431 3 12 3ZM18.5 4C19.8807 4 21 5.11929 21 6.5C21 7.88071 19.8807 9 18.5 9C17.1193 9 16 7.88071 16 6.5C16 5.11929 17.1193 4 18.5 4ZM5.5 4C6.88071 4 8 5.11929 8 6.5C8 7.88071 6.88071 9 5.5 9C4.11929 9 3 7.88071 3 6.5C3 5.11929 4.11929 4 5.5 4Z" fill="#ADA8A8"/>
                </svg>

                <input type="number" value="1" min="1" class="form-control" name="Number_People" v-model="booking.booking_info.Number_People" autocomplete="off" placeholder="Số lượng khách">
              </div>
              <div class="form-field one-half">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.77111 2.43923L8.8477 2.09522C9.85652 1.77287 10.9344 2.29382 11.3664 3.31256L12.2261 5.33991C12.6008 6.22336 12.3929 7.26227 11.7121 7.9084L9.81783 9.70641C9.93471 10.7819 10.2962 11.8409 10.9024 12.8834C11.5085 13.9259 12.2655 14.7907 13.1734 15.4778L15.4486 14.7191C16.311 14.4315 17.2502 14.762 17.7792 15.5392L19.0116 17.3498C19.6265 18.2532 19.5159 19.4995 18.7529 20.2655L17.9352 21.0865C17.1212 21.9036 15.9587 22.2 14.8833 21.8645C12.3444 21.0726 10.0101 18.7214 7.88034 14.8109C5.74747 10.8947 4.99472 7.57214 5.6221 4.84313C5.88609 3.69482 6.70361 2.78033 7.77111 2.43923Z" fill="#ADA8A8"/>
                </svg>

                <input type="text" class="form-control" name="user_id" v-model="booking.user_id" @change="formatNumberPhone"  v-mask="'###########'" autocomplete="off" placeholder="Số điện thoại">
              </div>

            </div>

            <div class="form-group one-half datepicker">
              <div class="form-field one-half">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 8.5V17.75C21 19.5449 19.5449 21 17.75 21H6.25C4.45507 21 3 19.5449 3 17.75V8.5H21ZM7.25 15C6.55964 15 6 15.5596 6 16.25C6 16.9404 6.55964 17.5 7.25 17.5C7.94036 17.5 8.5 16.9404 8.5 16.25C8.5 15.5596 7.94036 15 7.25 15ZM12 15C11.3096 15 10.75 15.5596 10.75 16.25C10.75 16.9404 11.3096 17.5 12 17.5C12.6904 17.5 13.25 16.9404 13.25 16.25C13.25 15.5596 12.6904 15 12 15ZM7.25 10.5C6.55964 10.5 6 11.0596 6 11.75C6 12.4404 6.55964 13 7.25 13C7.94036 13 8.5 12.4404 8.5 11.75C8.5 11.0596 7.94036 10.5 7.25 10.5ZM12 10.5C11.3096 10.5 10.75 11.0596 10.75 11.75C10.75 12.4404 11.3096 13 12 13C12.6904 13 13.25 12.4404 13.25 11.75C13.25 11.0596 12.6904 10.5 12 10.5ZM16.75 10.5C16.0596 10.5 15.5 11.0596 15.5 11.75C15.5 12.4404 16.0596 13 16.75 13C17.4404 13 18 12.4404 18 11.75C18 11.0596 17.4404 10.5 16.75 10.5ZM17.75 3C19.5449 3 21 4.45507 21 6.25V7H3V6.25C3 4.45507 4.45507 3 6.25 3H17.75Z" fill="#ADA8A8"/>
                </svg>

                <datetime type="date" format="yyyy-MM-dd" class="form-control"
                          name="Book_Date"
                          v-model="booking.booking_info.Book_Date"
                          :disabledDates="disabledDates"
                          autocomplete="off" placeholder="Chọn ngày"></datetime>
              </div>
              <div class="form-field one-half">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.25 13.5H11.25C10.836 13.5 10.5 13.164 10.5 12.75V6.75C10.5 6.336 10.836 6 11.25 6C11.664 6 12 6.336 12 6.75V12H15.25C15.664 12 16 12.336 16 12.75C16 13.164 15.664 13.5 15.25 13.5ZM12 2C6.478 2 2 6.478 2 12C2 17.522 6.478 22 12 22C17.522 22 22 17.522 22 12C22 6.478 17.522 2 12 2Z" fill="#ADA8A8"/>
                </svg>

                <datetime type="time" class="form-control" name="Book_Hour" v-model="bookingtime" autocomplete="off" placeholder="Chọn giờ" minute-step="15"></datetime>
              </div>

            </div>
            <div class="form-group">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.75 3C19.5449 3 21 4.45507 21 6.25V13H16.25C14.4551 13 13 14.4551 13 16.25V21H6.25C4.45507 21 3 19.5449 3 17.75V6.25C3 4.45507 4.45507 3 6.25 3H17.75ZM20.56 14.5L14.5 20.56V16.25C14.5 15.2835 15.2835 14.5 16.25 14.5H20.56Z" fill="#ADA8A8"/>
              </svg>

              <textarea class="form-control" rows="3" v-model="booking.booking_info.Note" placeholder="Ghi chú thêm"></textarea>
            </div>
            <div class="form-group">
                <button type="submit" class="btn" v-bind:class="{'loading':loading}">Xác nhận đặt bàn</button>
            </div>
        </form>
        <div class="message" v-if="stepActive==='2'" style="text-align: center;">
            <slot></slot>
        </div>
        <a class="more-info" href="/category/tin-tuc-suon-muoi/huong-dan-va-faqs/">
          Xem thông tin các của hàng của Sườn Mười
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.13633 2.85585C8.87407 2.59743 8.452 2.60056 8.1936 2.86283C7.93513 3.1251 7.93827 3.5472 8.20053 3.80561L11.7808 7.33321H2.66667C2.29847 7.33321 2 7.63168 2 7.99988C2 8.36808 2.29848 8.66655 2.66667 8.66655H11.7764L8.20053 12.1898C7.93827 12.4482 7.93513 12.8703 8.1936 13.1326C8.452 13.3949 8.87407 13.398 9.13633 13.1395L13.7525 8.59128C14.0837 8.26488 14.0837 7.73048 13.7525 7.40408L9.13633 2.85585Z" fill="#BC2030"/>
          </svg>
        </a>
    </div>
</template>

<script>
    export default {
        name: 'Booking',
        props:{
            stepActive: {
                type: String,
                default: "1"
            }
        },
        data () {
            return {
                api: this.$foodbookConfig.wpapi, //Api url
                booking: {
                    pos_id: this.$foodbookConfig.pos_id || 0,
                    pos_parent:this.$foodbookConfig.pos_name,
                    user_id: null,
                    username: null ,
                    booking_info: {
                        Book_Date: null,
                        Hour: null,
                        Minute: null,
                        Number_People: null,
                        Note: null
                    }
                },
                bookingtime: '',
                loading: false,
                validates: false,
                restaurants : [],
                pos: null,
                posSelecting: false,
                disabledDates: {
                  to: new Date(Date.now() - 8640000)
                }
            }
        },
        async created(){

          await this.getRestaurants();

        },
        mounted() {
            let ref = document.referrer;
            if(this.stepActive === '2' && !ref){
                window.location.replace(this.$foodbookConfig.homepage);
            }
        },
        watch: {
            bookingtime: function (val) {
                let $today = new Date(val);
                $today = $today.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
                let minute = $today.split(':')[1];
                this.booking.booking_info.Minute = minute.split(' ')[0];
                this.booking.booking_info.Hour = $today.split(':')[0];

            },
        },
        methods: {
            async getRestaurants() {

              let res = await fetch(this.api + '/restaurants')
                .then(response => response.json())
                .then(data => {
                  this.restaurants = data.list;
                  this.pos = data.list[0];
                });

            },
            selectChange (pos) {
              if (pos && pos.id) {
                this.pos = pos;
                this.booking.pos_id = pos.id;
              }
              this.posSelecting = false
            },
            nextStep() {
                this.stepActive = parseInt(this.stepActive) + 1;
            },
            formatNumberPhone() {
                if (!this.booking.user_id) return false;
                let firstChar = this.booking.user_id.substring(0, 1);
                //console.log(firstChar);
                if (firstChar === '0') {
                    this.booking.user_id = '84' + this.booking.user_id.substring(1)
                }
            },
            booking_online: function(event) {
                if (this.booking.username
                    && this.pos
                    && this.pos.id
                    && this.booking.user_id
                    && this.booking.booking_info.Book_Date
                    && this.booking.booking_info.Number_People
                    && this.booking.booking_info.Minute
                    && this.booking.booking_info.Hour) {
                    //Check format
                    if (this.booking.user_id.length < 11) {
                        this.validates = true;
                        this.$toasted.show("Số điện thoại phải hơn 10 số", {
                            position: "top-center",
                            duration: 5000,
                            type: 'error'
                        });
                        return;
                    }
                    if (this.booking.user_id.substring(0, 2) !== '84') {
                        this.validates = true;
                        this.$toasted.show("Số điện thoại không đúng (84xxxxxxx)", {
                            position: "top-center",
                            duration: 5000,
                            type: 'error'
                        });
                        return;
                    }
                    //Tạo đơn đặt bàn

                    this.loading = true;
                    let $date = new Date(this.booking.booking_info.Book_Date);
                    let dateY = $date.getFullYear();
                    let dateM = ("0" + ($date.getMonth() + 1)).slice(-2);
                    let dateD = ("0" + $date.getDate()).slice(-2);
                    this.booking.booking_info.Book_Date = dateY + '-' + dateM + '-' + dateD + ' 00:00:00';

                    this.$http.post(this.api + '/booking', this.booking, {method: 'POST'}).then(response => {
                        this.loading = false;
                        if (!response) {
                            this.$toasted.show("Hệ thống chưa xử lý được. Vui lòng thử lại sau..", {
                                position: "top-center",
                                duration: 5000,
                                type: 'error'
                            });
                        } else {
                            if (!response.body.error) {
                                this.$toasted.show("Đăng ký đặt bàn thành công!", {
                                    position: "top-center",
                                    duration: 5000,
                                    type: 'success'
                                });
                                //this.nextStep();
                                window.location.href = this.$foodbookConfig.bookingpage;
                            } else {
                                //this.$toasted.show(response.body.error.message, {
                                this.$toasted.show("Hệ thống chưa xử lý được. Vui lòng thử lại sau..", {
                                    position: "top-center",
                                    duration: 5000,
                                    type: 'error'
                                });
                            }
                        }
                    }, response => {
                        this.$toasted.show("Hệ thống chưa xử lý được. Vui lòng thử lại sau..", {
                            position: "top-center",
                            duration: 5000,
                            type: 'error'
                        });
                        this.loading = false;
                    });
                    this.validates = false;
                } else {
                    this.validates = true;
                    this.$toasted.show("Vui lòng điền đầy đủ thông tin", {
                        position: "top-center",
                        duration: 5000,
                        type: 'error'
                    });
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Booking.vue